import { Box, Container, Divider, Typography } from "@mui/material"

const steps = [
  {
    name: "1.お問い合わせ",
    content:
      "「お問い合わせフォーム」からご登録ください。1分間で完了できます。",
  },
  {
    name: "2.ヒアリング",
    content:
      "ご経歴やご希望を詳しくヒアリングした上で、案件をご提案いたします。",
  },
  {
    name: "3.案件の紹介",
    content: "案件をお選びいただき、商談の設定から成立までサポートいたします。",
  },
  {
    name: "4.企業との面接",
    content:
      "ご希望条件・単価・開始日などを企業と交渉し、募集企業との面接機会をセッティングします。",
  },
  {
    name: "5.企業との契約",
    content: "企業とエンジニア間で直接業務委託契約を締結します。",
  },
]
export default function LandingSteps() {
  return (
    <Box sx={{ mt: "10em" }}>
      <Typography
        variant="h3"
        color="primary"
        sx={{ textAlign: "center", mt: 5, fontWeight: "bold" }}
      >
        ご利用の流れ
      </Typography>
      <Divider sx={{ mx: 4, my: 2, borderBottomWidth: 2 }} />
      <Box sx={{ mx: "5em" }}>
        {steps.map((step, index) => (
          <Container sx={{ pb: 3 }} key={index}>
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              {step.name}
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              {step.content}
            </Typography>
          </Container>
        ))}
      </Box>
    </Box>
  )
}
